import React, { useState, useEffect } from "react";
import Upcolen from "../../assets/Homepage/Testimonial.svg";
import buttonarrowactive from "../../assets/Buttonarrow.svg";
import buttonarrowinactive from "../../assets/Buttoninactive.svg";

// import test1image from "../../assets/Homepage/TestimonialDesktop.png";
// import test2image from "../../assets/Homepage/testi2.jpg";

import test1 from "../../assets/Testimonials/Rectangle20.png"
import test2 from "../../assets/Testimonials/Rectangle9.png"
import test3 from "../../assets/Testimonials/Rectangle22.png"
import test4 from "../../assets/Testimonials/Rectangle21.png"
import test5 from "../../assets/Testimonials/Rectangle19.png"
import test6 from "../../assets/Testimonials/Rectangle28.png"

const testimonials = [
  {
    image: test1,
    quote: "",
    text: "I had a truly positive experience at this rehab center. The staff is compassionate, well-trained, and always supportive. They go above and beyond to make you feel heard, respected, and motivated. The environment is peaceful and clean, which really helps in the healing process.",
    author: "— Ambadas Bade (Patient)",
  },
  {
    image: test2,
    quote: "",
    text: "Best hospital in Thane. Excellent doctor, great humanitarian.I have not yet met any other Doctor like him who takes so much personal care of the patients.",
    author: "— Rahul pawar",
  },
  {
    image: test3,
    quote: "One of the Best Psychiatrists – Highly Trustworthy and Compassionate ",
    text: " Dr. Ketan Vaidya is an exceptional psychiatrist who combines deep medical expertise with genuine empathy. From the very first consultation, he makes you feel heard, understood, and supported without any judgment. He takes the time to explain the condition, treatment plan, and medication in a way that is easy to understand and reassuring.",
    author: "— Priyanka Budhkar",
  },
  {
    image: test4,
    quote: "",
    text: "Dr. Vaidya is like a mind magician! I was dealing with anxiety, and he helped me sort things out step by step. Super friendly and professional. Tyancha approach ekdum dilapasand aahe. Must visit for anyone struggling.",
    author: "— Shivganga Bade",
  },
  {
    image: test5,
    quote: "",
    text: "The inclusion of family support sessions was also invaluable, helping loved ones understand the recovery process and how to offer meaningful support......just amazing experience ",
    author: "— Prathmesh Patil",
  },
  {
    image: test6,
    quote: "",
    text: "Arambh Rehab run by Dr. ketan Vaidya is an Amazing Place for recovery! The environment is peaceful, and most importantly the staff is professional and helpful. Highly recommend.",
    author: "— Neetu shetty",
  },
];

export default function Testimonial() {
  const [index, setIndex] = useState(0);
  const [hoveredButton, setHoveredButton] = useState(null);

  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % testimonials.length);
    }, 3000);
    return () => clearInterval(timer);
  }, []);

  const prevTestimonial = () => {
    setIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  const nextTestimonial = () => {
    setIndex((prev) => (prev + 1) % testimonials.length);
  };

  const { image, quote, text, author } = testimonials[index];

  return (
    <section className="bg-[#E8EAF6] md:py-[80px] py-8 px-6">
      <div className="max-w-6xl mx-auto">
        {/* Heading */}
        <h2 className="font-garamond-subheading text-[#2C3075] mb-8 sm:mb-10 lg:mb-12 text-center sm:text-left">
          Real Feedback, Real <em>Results</em>
        </h2>

        {/* Content */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-start">
          {/* Image */}
          <div className="md:h-[400px] md:w-[410px]">
            <img
              src={image}
              alt="Smiling patient"
              className="rounded-[20px]  object-cover w-full h-full"
            />
          </div>

          {/* Text + Arrows */}
          <div className="flex flex-col justify-between relative">
            {/* Opening Quote Above Text */}

            <div>
              <img
                src={Upcolen}
                alt="Opening quote"
                className="mb-4 h-[35px] md:h-[80px] rotate-180"
               
              />
            </div>

            <div className="sm:ml-0">
              <p className="font-generalsans-description text-[24px] font-bold text-[#000020]  
              "  style={{ fontWeight: "300" }}>
                {quote}
              </p>

              <p className="font-generalsans-description pt-4 text-[#000020]">
                {text}
              </p>
            </div>

            {/* Author */}
            <p className="text-gray-500 italic mt-6" >{author}</p>

            {/* Closing Quote */}
            <img
              src={Upcolen}
              alt="Closing quote"
              className="absolute h-[35px] md:h-[80px] bottom-0 right-0"
              
            />

            {/* Navigation Arrows */}
            <div className="flex gap-4 mt-6">
              {/* Prev */}
              <button
                onClick={prevTestimonial}
                onMouseEnter={() => setHoveredButton("prev")}
                onMouseLeave={() => setHoveredButton(null)}
              >
                <img
                  src={
                    hoveredButton === "prev"
                      ? buttonarrowactive
                      : buttonarrowinactive
                  }
                  alt="Previous"
                  className="w-8 h-8 transform rotate-180 transition-transform duration-300"
                />
              </button>

              {/* Next */}
              <button
                onClick={nextTestimonial}
                onMouseEnter={() => setHoveredButton("next")}
                onMouseLeave={() => setHoveredButton(null)}
              >
                <img
                  src={
                    hoveredButton === "next"
                      ? buttonarrowactive
                      : buttonarrowinactive
                  }
                  alt="Next"
                  className="w-8 h-8 transition-transform duration-300"
                />
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
